<template>
  <div class="banner">
    <Carousel
      autoplay
      :autoplay-speed="speed"
      dots="inside"
      arrow="never"
      easing="ease-in-out"
    >
      <Carousel-item>
        <img src="@/assets/images/banner1.jpg" alt />
      </Carousel-item>
    </Carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      speed: 5000,
    };
  },
};
</script>

<style scoped>
.banner {
  /* width: 100%; */
  /* height: 670px; */
  width: 1000px;
  margin: 0 auto;
  background-color: #fff;
  padding: 20px 0;
}
img {
  /* width: 100%; */
  /* height: 650px; */
  width: 1000px;
  height: 340px;
}
</style>
